module.exports = __webpack_public_path__ + "home-block-3-overlay-nexuCrF.png";